import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  PackageSizeGrid,
  ColumnHeading,
  StyledTextField,
  StyledWrapper,
} from './package-size-and-weight.component.styles'
import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'

const PackageWeight = ({ weight }) => {
  const [t] = useTranslation()
  const preventEnteringDecimalOrHyphen = event => {
    if (event.key === '-' || event.key === '.') {
      event.preventDefault()
    }
  }

  return (
    <StyledWrapper>
      <PackageSizeGrid>
        <ColumnHeading>{t('label__weight')}</ColumnHeading>
      </PackageSizeGrid>
      <PackageSizeGrid>
        <StyledTextField
          data-testid="package-size-weight-field"
          showSuffix={t('suffix__kg')}
          input={weight.input}
          meta={weight.meta}
          type="number"
          onKeyPress={preventEnteringDecimalOrHyphen}
        />
      </PackageSizeGrid>
      <SmallText typographyStyles="mt-xs mb-m">
        {t('helper__weight_limit', { weight: 20 })}
      </SmallText>
    </StyledWrapper>
  )
}

PackageWeight.propTypes = {
  weight: PropTypes.object,
}

export { PackageWeight }
